import { createAction, props } from '@ngrx/store';

import { SoilType } from '../models/soil-type.models';

export const setSoilTypes = createAction(
  '[Soil type] Set soil types',
  props<{ soilTypes: SoilType[] }>(),
);
